const Icons = (width = 16, height = 16, fill = "#000000", className = '') => {
  return {
    Tick() {
      return <svg focusable="false" width={width} height={height} aria-hidden="true" viewBox="0 0 24 24" data-testid="DoneIcon"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" fill={fill}></path></svg>
    },
    Gateway() {
      return (
        <svg width={width} height={height} focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="DeviceHubIcon">
          <path fill={fill} d="m17 16-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5z"></path>
        </svg>
      )
    },
    Cloud() {
      return (
        <svg width={width} height={height} focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloudIcon">
          <path fill={fill} d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96"></path>
        </svg>
      )
    },
    Dashboard() {
      return (
        <svg width={width} height={height} focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="SpaceDashboardIcon">
          <path fill={fill} d="M11 21H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h6zm2 0h6c1.1 0 2-.9 2-2v-7h-8zm8-11V5c0-1.1-.9-2-2-2h-6v7z"></path>
        </svg>
      )
    },
    Optimize() {
      return (
        <svg width={width} height={height} focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ZoomInMapIcon">
          <path fill={fill} d="M9 9V3H7v2.59L3.91 2.5 2.5 3.91 5.59 7H3v2zm12 0V7h-2.59l3.09-3.09-1.41-1.41L17 5.59V3h-2v6zM3 15v2h2.59L2.5 20.09l1.41 1.41L7 18.41V21h2v-6zm12 0v6h2v-2.59l3.09 3.09 1.41-1.41L18.41 17H21v-2z"></path>
        </svg>
      )
    },
    Download() {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill={fill}>
          <path d="M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z" />
        </svg>
      )
    },
    Linkedin() {
      return (
      <svg width= {width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.2283 0H1.77167C1.30179 0 0.851161 0.186657 0.518909 0.518909C0.186657 0.851161 0 1.30179 0 1.77167V22.2283C0 22.6982 0.186657 23.1488 0.518909 23.4811C0.851161 23.8133 1.30179 24 1.77167 24H22.2283C22.6982 24 23.1488 23.8133 23.4811 23.4811C23.8133 23.1488 24 22.6982 24 22.2283V1.77167C24 1.30179 23.8133 0.851161 23.4811 0.518909C23.1488 0.186657 22.6982 0 22.2283 0ZM7.15333 20.445H3.545V8.98333H7.15333V20.445ZM5.34667 7.395C4.93736 7.3927 4.53792 7.2692 4.19873 7.04009C3.85955 6.81098 3.59584 6.48653 3.44088 6.10769C3.28591 5.72885 3.24665 5.31259 3.32803 4.91145C3.40941 4.51032 3.6078 4.14228 3.89816 3.85378C4.18851 3.56529 4.55781 3.36927 4.95947 3.29046C5.36112 3.21165 5.77711 3.25359 6.15495 3.41099C6.53279 3.56838 6.85554 3.83417 7.08247 4.17481C7.30939 4.51546 7.43032 4.91569 7.43 5.325C7.43386 5.59903 7.38251 5.87104 7.27901 6.1248C7.17551 6.37857 7.02198 6.6089 6.82757 6.80207C6.63316 6.99523 6.40185 7.14728 6.14742 7.24915C5.893 7.35102 5.62067 7.40062 5.34667 7.395ZM20.4533 20.455H16.8467V14.1933C16.8467 12.3467 16.0617 11.7767 15.0483 11.7767C13.9783 11.7767 12.9283 12.5833 12.9283 14.24V20.455H9.32V8.99167H12.79V10.58H12.8367C13.185 9.875 14.405 8.67 16.2667 8.67C18.28 8.67 20.455 9.865 20.455 13.365L20.4533 20.455Z" fill={fill}/>
      </svg>
      )
    },
    building() {
      return (
        <svg width={width} height={height} fill="none" stroke="currentColor" viewbox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
         </svg>
      )
    },
    circleTick() {
      return (
        <svg width={width} height={height} fill="none" stroke="currentColor" viewbox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    idea() {
      return (
        <svg width={width} height={height} class="w-6 h-6 text-purple-600" fill = "none" stroke="currentColor" viewbox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      )
    },
    currentCircle() {
      return (
        <svg width={width} height={height} class="w-8 h-8" fill="currentColor" viewbox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
      )
    },  
    pendrive() {
      return (
        <svg width={width} height={height} class="w-8 h-8" fill="currentColor" viewbox="0 0 24 24">
          <path d="M9 11H7v9a2 2 0 002 2h8a2 2 0 002-2V9h-2m-1-1V6a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
        </svg>
      )
    },
    loading() {
      return (
        <svg width={width} height={height} class="w-8 h-8" fill="currentColor" viewbox="0 0 24 24">
          <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z" />
        </svg>
      )
    },
    star() {
      return (
        <svg width={width} height={height} class="w-8 h-8" fill="currentColor" viewbox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      )
    },
    factory() {
      return (
        <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 640 640">
          <path d="M96 96C78.3 96 64 110.3 64 128L64 496C64 522.5 85.5 544 112 544L528 544C554.5 544 576 522.5 576 496L576 216.2C576 198 556.6 186.5 540.6 195.1L384 279.4L384 216.2C384 198 364.6 186.5 348.6 195.1L192 279.4L192 128C192 110.3 177.7 96 160 96L96 96z"/>
        </svg>
      )
    },
    energy() {
      return (
        <svg class={className} width={width}  height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 2L6 13H11L10 22L18 10H13V2Z"
            stroke="#6A4CF4"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"/>
        </svg>
      )
    },
    wrench() {
      return (
        <svg class={className} width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 6.5A4.5 4.5 0 0 1 15.5 11L7 19.5A2 2 0 1 1 4.5 17L13 8.5A4.5 4.5 0 0 1 17.5 3L15 5.5L18.5 9L21 6.5Z"
                stroke="#6A4CF4"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      )
    },
    monitor() {
      return (
        <svg class={className} width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="4" width="18" height="12" rx="1.5"
                stroke="#6A4CF4"
                stroke-width="1.8"/>
          <path d="M8 20H16M12 16V20"
                stroke="#6A4CF4"
                stroke-width="1.8"
                stroke-linecap="round"/>
          <path d="M7 12L10 9L13 11L17 7"
                stroke="#6A4CF4"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      )
    },
    clipboard() {
      return (
        <svg class={className} width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="6" y="3" width="12" height="18" rx="2"
                stroke="#6A4CF4"
                stroke-width="1.8"/>
          <path d="M9 3.5H15V6H9V3.5Z"
                stroke="#6A4CF4"
                stroke-width="1.8"/>
          <path d="M9 10H15M9 14H15M9 18H13"
                stroke="#6A4CF4"
                stroke-width="1.8"
                stroke-linecap="round"/>
        </svg>
      )
    },
    cloud() {
      return (
        <svg class={className} width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 18H17C19.2 18 21 16.2 21 14C21 11.9 19.4 10.2 17.4 10C17.1 7.2 14.8 5 12 5C9.6 5 7.5 6.6 6.9 8.9C4.7 9.1 3 11 3 13.3C3 15.9 5.1 18 7.7 18H7Z"
                stroke="#6A4CF4"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      )
    },
    mobile() {
      return (
        <svg class={className} width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="7" y="2.5" width="10" height="19" rx="2"
                stroke="#6A4CF4"
                stroke-width="1.8"/>
          <path d="M10 5H14" stroke="#6A4CF4" stroke-width="1.8" stroke-linecap="round"/>
          <circle cx="12" cy="18.5" r="0.8" fill="#6A4CF4"/>
        </svg>
      )
    },
    router() {
      return (
        <svg class={className} width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="10" width="16" height="7" rx="1.5"
                stroke="#6A4CF4"
                stroke-width="1.8"/>
          <path d="M12 10V4" stroke="#6A4CF4" stroke-width="1.8" stroke-linecap="round"/>
          <circle cx="8" cy="13.5" r="0.8" fill="#6A4CF4"/>
          <circle cx="12" cy="13.5" r="0.8" fill="#6A4CF4"/>
          <circle cx="16" cy="13.5" r="0.8" fill="#6A4CF4"/>
        </svg>
      )
    },
    antenna() {
      return (
        <svg class={className} width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 18V22"
                stroke="#6A4CF4"
                stroke-width="1.8"
                stroke-linecap="round"/>

          <path d="M10 22H14"
                stroke="#6A4CF4"
                stroke-width="1.8"
                stroke-linecap="round"/>

          <path d="M12 18L10 22M12 18L14 22"
                stroke="#6A4CF4"
                stroke-width="1.8"
                stroke-linecap="round"/>

          <path d="M8 15C10 13 14 13 16 15"
                stroke="#6A4CF4"
                stroke-width="1.8"
                stroke-linecap="round"/>

          <path d="M5.5 12C8.5 9 15.5 9 18.5 12"
                stroke="#6A4CF4"
                stroke-width="1.8"
                stroke-linecap="round"/>

          <path d="M3 9C7 5 17 5 21 9"
                stroke="#6A4CF4"
                stroke-width="1.8"
                stroke-linecap="round"/>
        </svg>
      )
    }
  }
}
export default Icons;